import { render, staticRenderFns } from "./CalendarItem.vue?vue&type=template&id=7b2029a9&scoped=true&"
import script from "./CalendarItem.vue?vue&type=script&lang=js&"
export * from "./CalendarItem.vue?vue&type=script&lang=js&"
import style0 from "./CalendarItem.vue?vue&type=style&index=0&id=7b2029a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2029a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b2029a9')) {
      api.createRecord('7b2029a9', component.options)
    } else {
      api.reload('7b2029a9', component.options)
    }
    module.hot.accept("./CalendarItem.vue?vue&type=template&id=7b2029a9&scoped=true&", function () {
      api.rerender('7b2029a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/management/CalendarItem.vue"
export default component.exports